export default "__VITE_ASSET__BpKiIXOd__"